// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__NICuz","container":"style_container__2gL1V"};